// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"352":"bc331ae4","637":"86ad2fe8","765":"50fd5a05","938":"36e35b1e"}[chunkId] + ".chunk.js");